/**
 * The week panel's header: which week this is, whose it is, and the way to step off it.
 * Split from WeekPanel on the CD-1 module budget when the works-order route moved inside
 * the list — the panel grew a render prop and had to give something back.
 */

import React from 'react'
import type { WeekModel, ResourceModel } from '../../viewmodels/loading'
import { weekFull } from './format'

function Nav({ week, name, onWeek, last }: {
  week: number
  name: string
  onWeek: (index: number) => void
  last: number
}): React.JSX.Element {
  const button = (label: string, to: number, on: boolean): React.JSX.Element => (
    <button
      type="button"
      disabled={!on}
      aria-label={label === '‹' ? 'Previous week' : 'Next week'}
      onClick={() => onWeek(to)}
      className="h-6 w-6 rounded-[5px] border font-sans text-[13px] font-semibold leading-none"
      style={{
        borderColor: 'var(--lc-b12)',
        background: on ? 'var(--lc-card)' : 'var(--lc-disabled)',
        color: on ? 'var(--lc-ink)' : 'var(--lc-hair)',
      }}
    >
      {label}
    </button>
  )
  return (
    <div className="flex items-center gap-2">
      <span className="font-sans text-[10.5px]" style={{ color: 'var(--lc-faint)' }}>click a column, or step through</span>
      <div className="flex gap-1">
        {button('‹', Math.max(0, week - 1), week > 0)}
        {button('›', Math.min(last, week + 1), week < last)}
      </div>
      <span className="sr-only">{name}</span>
    </div>
  )
}

export default function WeekPanelHead({ r, w, week, onWeek }: {
  r: ResourceModel
  w: WeekModel
  week: number
  onWeek: (index: number) => void
}): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 border-b px-4 py-3" style={{ borderColor: 'var(--lc-b09)' }}>
      <div className="flex items-baseline gap-2.5">
        <span className="font-sans text-[13.5px] font-semibold" style={{ color: 'var(--lc-ink)' }}>{weekFull(w.weekStart)}</span>
        <span className="font-mono text-[10.5px]" style={{ color: 'var(--lc-mut)' }}>{r.name} · levelled</span>
      </div>
      <Nav week={week} name={r.name} onWeek={onWeek} last={r.weeks.length - 1} />
    </div>
  )
}
